import "./MoreInformation.css";
export const Responsibilities = (
  <div className="info-container small flex flex-row mr-auto ml-auto">
    <div className="info-column small flex flex-column ">
      <text className="sub-title">Roles & responsibilities</text>
      <text className="paragraph">
        Roles and responsibilities are important in a co-founder alignment
        because they help to establish clear expectations and ensure that each
        founder understands their specific contribution to the company.
      </text>
      <text className="paragraph">
        By clearly defining roles and responsibilities, co-founders can ensure
        that they are playing to their individual strengths and expertise. This
        can help to optimize the performance of the team and increase the
        chances of success for the company.
      </text>
      <text className="paragraph">
        Another reason to clearly define roles & responsibilities is to
        incentivize co-founders to fulfill their roles and responsibilities in
        the company. Vesting (i.e. earning your shares) typically involves a
        time-based or milestone-based schedule for the distribution of equity or
        ownership in the company. Co-founders may be penalized by vesting if
        they fail to meet certain milestones or responsibilities that have been
        agreed upon in advance.
      </text>
      <text className="paragraph">
        For example, if a co-founder has been tasked with meeting a certain
        revenue target or developing a specific product feature, and they fail
        to meet that target or deliver that feature within the agreed-upon
        timeframe, they may lose a portion of their equity or ownership in the
        company.
      </text>
      <text className="paragraph">
        In this tool, only a time-based vesting schedule is foreseen (for now).
        However, it is still beneficial to conduct the exercise of agreeing on
        each founder's roles and responsibilities for the reasons above.
      </text>
    </div>
  </div>
);
